import React from "react";
import LoadingSkeleton from "./";

const TournamentCardLoader = () => <LoadingSkeleton height={380} />;
export default TournamentCardLoader;
